// extracted by mini-css-extract-plugin
module.exports = {"tab_wrapper":"Tabs_tab_wrapper__3NzMT","line":"Tabs_line__2EwlM","tab":"Tabs_tab__28Mkm","active":"Tabs_active__2hPHG","tab_content_wrapper":"Tabs_tab_content_wrapper__szptB"};